import { render, staticRenderFns } from "./kflist.vue?vue&type=template&id=249a1cc5&scoped=true&"
import script from "./kflist.vue?vue&type=script&lang=ts&"
export * from "./kflist.vue?vue&type=script&lang=ts&"
import style0 from "./kflist.vue?vue&type=style&index=0&id=249a1cc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a1cc5",
  null
  
)

export default component.exports